/** Hostnames that serve the web app + /api proxy (production, staging, Pages previews). */
export function isMarketplaceDeployHost(hostname) {
  if (!hostname) return false;
  return (
    hostname === 'flea-marketplace.com'
    || hostname === 'www.flea-marketplace.com'
    || hostname === 'staging.flea-marketplace.com'
    || hostname.endsWith('.pages.dev')
    || hostname === 'localhost'
    || hostname === '127.0.0.1'
  );
}

/**
 * Site origin only (no /api suffix).
 * Auth clients use baseURL=origin and paths like `/api/otp/send/`.
 */
export function normalizeMonolithOrigin(url) {
  if (!url) return url;
  let normalized = String(url).trim().replace(/\/+$/, '');
  normalized = normalized.replace(/\/api$/i, '');
  return normalized;
}

/** https://staging.flea-marketplace.com etc., or null when not on a deployed host. */
export function getMarketplaceDeployOrigin() {
  if (typeof window === 'undefined') return null;
  const { hostname, origin } = window.location;
  if (!isMarketplaceDeployHost(hostname)) return null;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null;
  return origin;
}

/** https://staging.flea-marketplace.com/api etc., or null when not on a deployed host. */
export function getMarketplaceApiBaseUrl() {
  const origin = getMarketplaceDeployOrigin();
  return origin ? `${origin}/api` : null;
}

/** Same-origin API base in production/staging so Cloudflare /api/* proxy and cookies work. */
export function resolveMonolithApiBaseUrl(envKeys = [], localFallback = 'http://localhost:8007') {
  const deployOrigin = getMarketplaceDeployOrigin();
  if (deployOrigin) {
    return normalizeMonolithOrigin(deployOrigin);
  }

  if (typeof window !== 'undefined' && isMarketplaceDeployHost(window.location.hostname)) {
    return normalizeMonolithOrigin(window.location.origin);
  }

  for (const key of envKeys) {
    const value = process.env[key];
    if (value) {
      const trimmed = normalizeMonolithOrigin(value);
      // Legacy envs pointed at per-service hosts (e.g. .../giftcards); monolith uses same-origin /api.
      if (!/\/giftcards$|\/points$|\/wallet$/i.test(trimmed)) {
        return trimmed;
      }
    }
  }

  return normalizeMonolithOrigin(localFallback);
}

/** Accounts/auth API origin — paths are `/api/login/`, `/api/otp/send/`, etc. */
export function getAccountsApiOrigin() {
  return resolveMonolithApiBaseUrl(['REACT_APP_API_BASE_URL'], 'http://localhost:8001');
}
